import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {
  isLoggedIn = false;
  user: any = null;
  loading = false;
  searchQuery = '';

  pqrsData = {
    fullName: '',
    documentId: '',
    email: '',
    phone: '',
    requestType: 'Petición',
    orderNumber: '',
    description: '',
    userId: ''
  };

  faqs = [
    {
      question: '¿Cómo funciona el Pago Contra Entrega (COD)?',
      answer: 'Solicitas tu pedido y pagas en efectivo o Nequi directamente al mensajero de la transportadora (Servientrega, Coordinadora, Interrapidísimo o TCC) en la puerta de tu casa.',
      open: false
    },
    {
      question: '¿Qué pasa si mi pedido se demora o no me encuentran?',
      answer: 'La transportadora realiza hasta 2 reintentos de entrega. Te notificaremos por SMS y WhatsApp con el número de guía para que reprogrames la hora.',
      open: false
    },
    {
      question: '¿Cómo solicito un cambio de talla sin costo?',
      answer: 'Puedes radica una solicitud en esta sección seleccionando "Cambio de Talla". El primer cambio es 100% gratuito.',
      open: false
    },
    {
      question: '¿Cómo me entregan la Factura Electrónica DIAN?',
      answer: 'Tu factura electrónica se emite automáticamente una vez entregado el pedido y la puedes descargar en tu perfil en formato PDF con su respectivo CUFE.',
      open: false
    }
  ];

  constructor(private apiService: ApiService) {}

  ngOnInit(): void {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      try {
        this.user = JSON.parse(userStr);
        this.isLoggedIn = true;
        this.pqrsData.fullName = this.user.name || `${this.user.first_name || ''} ${this.user.last_name || ''}`.trim();
        this.pqrsData.email = this.user.email || '';
        this.pqrsData.phone = this.user.phone || '';
        this.pqrsData.documentId = this.user.document || this.user.dni || '';
        this.pqrsData.userId = this.user.id || '';
      } catch (e) {
        console.error('Error parsing user data:', e);
      }
    }
  }

  toggleFaq(index: number): void {
    this.faqs[index].open = !this.faqs[index].open;
  }

  submitPqrs(): void {
    if (!this.pqrsData.fullName || !this.pqrsData.email || !this.pqrsData.description) {
      Swal.fire('Campos requeridos', 'Por favor completa el nombre, correo y la descripción de tu solicitud.', 'warning');
      return;
    }

    this.loading = true;
    this.apiService.post('pqrs', this.pqrsData).subscribe(
      (res: any) => {
        this.loading = false;
        Swal.fire({
          icon: 'success',
          title: '¡Solicitud Radicada!',
          html: `<p>Tu ticket <strong>${res.ticketNumber || 'PQRS-2026'}</strong> fue recibido con éxito.</p><small>Recibirás una respuesta en tu correo en menos de 24 horas hábiles.</small>`,
          confirmButtonColor: '#2563eb'
        });
        this.pqrsData.description = '';
        this.pqrsData.orderNumber = '';
      },
      (err: any) => {
        this.loading = false;
        console.error('Error al radicar PQRS:', err);
        Swal.fire('Error', 'No se pudo registrar la solicitud. Intenta nuevamente.', 'error');
      }
    );
  }
}
